'use strict';

var isObject = require('../../../../motion-utils/dist/es/is-object.cjs');

/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */
function isSVGElement(element) {
    return isObject.isObject(element) && "ownerSVGElement" in element;
}

exports.isSVGElement = isSVGElement;
//# sourceMappingURL=is-svg-element.cjs.map
